<template>
    <!-- 主要功能 -->
    <div class="key_feature">
        <div class="containers">
            <h1 class="partH1" ref="HeaderTitle">主要功能</h1>
            <ul ref="ul" class="feature_ul_bg">
                <li v-for="(item,i) in keyFeature.part1" :key="i"  class="feature_bg" :style="{background: 'url('+item.bg+')' }">
                    <div class="feature_title"><span>{{item.title}}</span></div>
                    <div class="feature_info_bg">
                        <div class="feature_info">{{item.info}}</div>
                    </div>
                </li>
            </ul>

            <ul ref="ul2" class="feature_ul_bg">
                <li v-for="(item,i) in keyFeature.part2" :key="i"  class="feature_bg" :style="{background: 'url('+item.bg+')' }">
                    <div class="feature_title"><span>{{item.title}}</span></div>
                    <div class="feature_info_bg">
                        <div class="feature_info">{{item.info}}</div>
                    </div>
                </li>

            </ul>
        </div>
    </div>

</template>

<script>
    import animationUtils from "@/utils/animationUtils.js";
    import animationIndex from "@/utils/animationIndex.js";
    
    export default {
        props: {
            keyFeature: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                // liDom: [],
            }
        },
        mounted() {
            // this.keyFeature.forEach((item, index) => { //获取需要给加动画的各个li的ref节点
            //     this.liDom.push(this.$refs[`li${index}`][0].classList);
            // })

            window.addEventListener("scroll", this.menu);
        },
        beforeDestroy() { //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
            window.removeEventListener("scroll", this.menu)
        },
        methods: {
            menu() {
                let ulOffsetTop = this.$refs.ul.offsetTop; //获取当前元素距离文档顶部的高度
                let ulList = this.$refs.ul.classList; //获取当前元素距离文档顶部的高度
                let ul2OffsetTop = this.$refs.ul2.offsetTop; //获取当前元素距离文档顶部的高度
                let ul2List = this.$refs.ul2.classList; //获取当前元素距离文档顶部的高度
                /**
                 * animationIndex第一个参数为需要动画的dom元素的高度，
                 * 第二个参数为li的每个单元的dom样式类数组
                 * 第三个参数为动画样式类名称
                 * 第四个参数为每个li动画执行间隔时间
                 * */
                // animationIndex.animationIndex(ulOffsetTop, this.liDom, "fade--in", 600);

                /**
                 * animations方法的第一个参数是需要动画的dom元素的高度，
                 * 第二个参数是需要加动画的dom元素的样式列表数组，
                 * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
                 */
                //第二部分标题动画
                let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
                let HeaderTitle = this.$refs.HeaderTitle.classList;
                
                animationUtils.animations(ulOffsetTop, ulList, "activeTitle");
                animationUtils.animations(ul2OffsetTop, ul2List, "activeTitle");
                animationUtils.animations(HeaderTitleOffsetTop, HeaderTitle, "activeTitle");
            }
        },
    };
</script>

<style scoped>
    @media screen and (max-width: 898px) {
        .feature_bg .feature_info {
            width: 150px;
            font-size: 12px;
            line-height: 1.5em;
        }

        .feature_bg .feature_title {
            font-size: 16px;
        }

        .key_feature ul li {
            width: 180px;
            height: 180px;
        }
    }

    @media screen and (min-width: 898px) and (max-width: 1067px) {
        .key_feature ul li {
            width: 200px;
            height: 200px;
        }

        .feature_bg .feature_title {
            font-size: 18px;
        }

        .feature_bg .feature_info {
            width: 170px;
            font-size: 13px;
            line-height: 1.5em;
        }
    }

    @media screen and (min-width: 1067px) {
        .key_feature ul li {
            width: 14.58333vw;
            height: 14.58333vw;
        }

        .feature_bg .feature_info {
            width: 10.67708vw;
            font-size: 0.9375vw;
            line-height: 1.45833vw;
        }

        .feature_bg .feature_title {
            font-size: 1.25vw;
        }
    }
</style>